import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrQuestionMark = ({ onClick }) => (
  <SrBox
    backgroundColor='#B7B7B7'
    width='40px'
    height='40px'
    borderRadius='24px'
    className='SrQuestionMark'
    onClick={onClick}
  >
    <SrBox position='relative' top='7px'>
      <SrText
        align='center'
        display='block'
        color='white'
        font='greycliff'
        size='23'
        weight='bolder'
      >
        ?
      </SrText>
    </SrBox>
  </SrBox>
);

SrQuestionMark.propTypes = {
  onClick: PropTypes.func.isRequired,
};

SrQuestionMark.displayName = 'SrQuestionMark';

export default SrQuestionMark;
